import React from 'react'
import Header from "../Components/Component/Header"
import Contact_Bg from '../Components/Component/Contact_Bg'
import ContactFormMap from '../Components/Component/Contact_Form'
import Footer from '../Components/Component/Footer'
const Contact = () => {
  return (
    <div>
       
        <Contact_Bg />
        <ContactFormMap />
        <Footer />
    </div>
  )
}

export default Contact